(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xem-best-seller-card"] && !Shopify.designMode) return;
  try {
    if (!window.xemBestSellerShareInitialized) {
    window.xemBestSellerShareInitialized = true;

    document.addEventListener('click', async (event) => {
      const shareButton = event.target.closest('[data-xem-share]');

      if (!shareButton) {
        return;
      }

      const shareTitle = shareButton.getAttribute('data-share-title') || document.title;
      const shareUrl = shareButton.getAttribute('data-share-url') || window.location.href;

      try {
        if (navigator.share) {
          await navigator.share({ title: shareTitle, url: shareUrl });
          return;
        }

        await navigator.clipboard.writeText(shareUrl);
        shareButton.setAttribute('aria-label', 'Product link copied');
      } catch (error) {
        shareButton.setAttribute('aria-label', 'Unable to share product');
        return;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
